import CheckoutStepsConfig from '@/v-shop/checkout/common/checkout-steps-config'
CheckoutStepsConfig.bvip = function () {
	return {
		title: 'Descuentos para Socios del Club',
		editable: true,
	}
}

